import { NewMost } from '@/components/blocks/NewMost';
import { ID } from '@/data/types/Basic';
import { FC } from 'react';


export const ContentMostNew: FC<{ id: ID }> = () => {
	const data: {
		title: string;
		category: string;
		image: string;
		price: string;
		colors: string[];
	}[] = [
		{
			title: 'Tenis Under Armour Hovr Phantom 3 Se',
			category: 'Calzado Hombre',
			image: 'EmeraldSAS/images/promotion/home/tennis_1.webp',
			price: '$150.00',
			colors: ['#C0474A', '#C46D52', '#242424'],
		},
		{
			title: 'Tenis Under Armour Hovr Phantom 3 Se',
			category: 'Calzado Hombre',
			image: 'EmeraldSAS/images/promotion/home/tennis_2.webp',
			price: '$150.00',
			colors: ['#C0474A', '#C46D52', '#242424'],
		},
		{
			title: 'Tenis Under Armour Hovr Phantom 3 Se',
			category: 'Calzado Hombre',
			image: 'EmeraldSAS/images/promotion/home/tennis_3.webp',
			price: '$150.00',
			colors: ['#C0474A', '#C46D52', '#242424'],
		},
		{
			title: 'Tenis Under Armour Hovr Phantom 3 Se',
			category: 'Calzado Hombre',
			image: 'EmeraldSAS/images/promotion/home/tennis_1.webp',
			price: '$150.00',
			colors: ['#C0474A', '#C46D52', '#242424'],
		},
		{
			title: 'Tenis Under Armour Hovr Phantom 3 Se',
			category: 'Calzado Hombre',
			image: 'EmeraldSAS/images/promotion/home/tennis_2.webp',
			price: '$150.00',
			colors: ['#C0474A', '#C46D52', '#242424'],
		},
		{
			title: 'Tenis Under Armour Hovr Phantom 3 Se',
			category: 'Calzado Hombre',
			image: 'EmeraldSAS/images/promotion/home/tennis_3.webp',
			price: '$150.00',
			colors: ['#C0474A', '#C46D52', '#242424'],
		},
	];

	return <NewMost title='LO MAS NUEVO' products={data} buttons={['Hombre', 'Mujer', 'Niños']}/>;
};
